import { trainingContent } from '@/content/training/training';

const fetchContent = async () => {
  return trainingContent;
};

export default fetchContent;
